module.exports = __webpack_public_path__ + "img/GotoOverview.1d13baa2.svg";